import styled from 'styled-components';

export const Legend = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;
